/* src/app/booking-overview/components/no-longer-valid/no-longer-valid.component.scss */
.no-longer-valid-container {
  height: calc(100vh - 64px);
}
@media (max-width: 575px) {
  .no-longer-valid-container .invalid-container {
    padding: 3rem;
  }
}
/*# sourceMappingURL=no-longer-valid.component.css.map */
